module.exports = __webpack_public_path__ + "static/logo-new-3750af6c205811ee9ecf89a793e1538b.svg";